export const environment = {
  production: true,
  apiAddress: 'https://api.gtcompany.staging.makeo.fr/',
  gridDefaultPageIndex: 0,
  gridDefaultPageSize: 10,
  gridPageSizeArray: [5, 10, 50, 100],
};
